import { IPageBreak } from '../../interface/PageBreak'

export const defaultPageBreakOption: Readonly<Required<IPageBreak>> = {
  font: 'Microsoft YaHei',
  fontSize: 12,
  lineDash: [3, 1]
}
